module.exports = __webpack_public_path__ + "static/img/qrcode-empty.1769678785359.png";